import { Routes } from '@angular/router';
import { ERoutes } from '../../types/app-routes';
import { scannerResultsDeactivateGuard } from './scanner-results/guards/scanner-results-deactivate.guard';
import { scannerDraftResolver } from './scanner-results/resolvers/scanner-draft.resolver';

export const scannerResultsRoutes: Routes = [
  {
    path: ERoutes.RESULTS,
    children: [
      {
        path: '',
        canDeactivate: [scannerResultsDeactivateGuard],
        resolve: { scannerDraft: scannerDraftResolver },
        loadComponent: () =>
          import('./scanner-results/scanner-results.component').then(
            (m) => m.ScannerResultsComponent
          ),
      },
    ],
  },
];
